/**
 * @deprecated This file is deprecated. Please import from the specific service files:
 * - orderService for order-related operations
 * - returnService for return-related operations  
 * - configService for configuration-related operations
 * - decisionCodeService for decision code operations
 * - setLanguage from languageStore
 */

import { orderService } from './orderService';
import { returnService } from './returnService';
import { configService } from './configService';
import { decisionCodeService } from './decisionCodeService';
import { setLanguage } from './languageStore';

// Re-export types that consumers might need
export type {
    OrderForReturnDTO,
    ReturnSlip,
    ReturnOrderHeader,
    ReturnStatusStatistic,
    ReturnOverviewDtoPageInfo,
    AppContextIdName,
    ReturnCenterDisplaySettingsResponse,
    ReturnCenterSettings,
    ReturnLogItem,
    OrderDeliveryInfo,
    DetermineDecisionCodesRequest,
    DetermineDecisionCodesResponse,
    DecisionCodesResult,
} from 'returnCenter-api';

/**
 * @deprecated Use orderService, returnService, configService, or decisionCodeService directly instead
 * This object is maintained for backwards compatibility only
 */
const order = {
    // Order endpoints - delegate to orderService
    orderGetOrder: orderService.getOrder,
    orderGetOrders: orderService.getOrders,
    orderGetOrderDeliveryInfo: orderService.getOrderDeliveryInfo,
    orderGetOrderByBarcode: orderService.getOrderByBarcode,

    // Return endpoints - delegate to returnService
    orderGetReturn: returnService.getReturn,
    orderCreateReturn: returnService.createReturn,
    orderUpdateReturn: returnService.updateReturn,
    orderDeleteReturn: returnService.deleteReturn,
    orderCreateReturnCredit: returnService.createReturnCredit,
    orderSearchReturns: returnService.searchReturns,
    orderGetReturnStatistics: returnService.getReturnStatistics,
    orderGetReturnLogs: returnService.getReturnLogs,
    orderAddReturnLog: returnService.addReturnLog,
    orderUpdateReturnLogPinned: returnService.updateReturnLogPinned,

    // Configuration endpoints - delegate to configService
    orderGetCompanies: configService.getCompanies,
    orderGetAppDisplaySettings: configService.getAppDisplaySettings,
    orderGetReturnCenterSettings: configService.getReturnCenterSettings,

    // Decision code endpoints - delegate to decisionCodeService
    orderGetDecisionCodesForCustomer: decisionCodeService.getDecisionCodesForCustomer,

    // Language management - delegate to languageStore
    setLanguage,
};

export { order };

// Also export individual services for new code
export { orderService, returnService, configService, decisionCodeService, setLanguage };
